import httpService from "./httpService";
import utils from "./utils";

export default {

  findAll(example, pageable, commentIds) {
    pageable = utils.initPageableParams(pageable);
    var params = utils.merge(utils.merge(example, pageable), {commentIds: commentIds});
    return httpService.get("vbCommentToUserView", {params: params});
  },
}



// WEBPACK FOOTER //
// ./src/services/vbCommentToUserViewService.js